var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagDemocraticRepublicOfCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.223 8.66342C29.4837 7.23099 28.5146 5.88649 27.3139 4.68574C26.1131 3.48492 24.7685 2.51586 23.3361 1.77661L12.0643 12.0645L1.77637 23.3363C2.51568 24.7687 3.48474 26.1133 4.68549 27.314C5.88624 28.5148 7.2308 29.4839 8.66318 30.2232L19.935 19.9352L30.223 8.66342Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68542 27.3142C5.35661 27.9854 6.0728 28.584 6.82398 29.1111L29.1105 6.82447C28.5835 6.07329 27.9849 5.3571 27.3137 4.68591C26.6425 4.01472 25.9264 3.41616 25.1752 2.88916L2.88867 25.1757C3.41561 25.9267 4.01417 26.643 4.68542 27.3142Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68576 4.68575C-0.362177 9.73368 -1.33124 17.3148 1.77664 23.3364L23.3364 1.77668C17.3148 -1.33113 9.73363 -0.361942 4.68576 4.68575Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3145 27.3141C32.3624 22.2663 33.3314 14.6851 30.2237 8.66357L8.66394 30.2233C14.6855 33.3311 22.2667 32.3621 27.3145 27.3141Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52663 4.86914L9.39 7.52645H12.184L9.92363 9.1687L10.787 11.826L8.52663 10.1836L6.26613 11.826L7.12963 9.1687L4.86913 7.52645H7.66313L8.52663 4.86914Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDemocraticRepublicOfCongo);
export default __webpack_public_path__ + "static/media/flag_democratic_republic_of_congo.adc684ae5d16d865c0ec34f376352a6e.svg";
export { ForwardRef as ReactComponent };